module.exports = __webpack_public_path__ + "static/media/sniper.34f320c5.png";